import {mapGetters} from "vuex";

export const blobsLoader = {
    data: function() {
        return {
            blobs: undefined
        }
    },

    created() {
        // load blobs on create
        this.loadBlobs(this.currentRadarId)
    },

    computed: {
        ...mapGetters({
            currentRadarId: 'radars/getCurrentRadarId'
        }),
        isLoading: function () {
            return (this.blobs === undefined)
        }
    },

    methods: {
        loadBlobs(id) {
            if(!this.$store.getters['radars/isRadarInitialised'](id))
            {
                // load blobs from server
                this.$store.dispatch('blobs/loadRadarBlobs', id)
                    .then(() => {
                        this.$store.commit('radars/setRadarInitialised', id);
                        this.blobs = this.$store.getters['blobs/getRadarBlobs'](id);
                    })
            }
            else {
                // get blobs
                this.blobs = this.$store.getters['blobs/getRadarBlobs'](id)
            }
        }
    },

    watch: {
        // load blobs if radar was changed
        currentRadarId: function (radarId) {
            this.loadBlobs(radarId)
        }
    }
}
